export enum APPLICATIONS_FILTER_STATUSES {
  APPLICATION_STATUS = 'statuses',
  RISK_STATUS = 'riskStatuses',
  OPERATIONS_STATUS = 'operationsStatuses',
}

export enum APPLICATION_SUMMARY {
  RISK = 'Applications in Underwriting',
  OPERATIONS = 'Applications in Operations',
}
